import { axios as request } from "../../request/http";

const interfaceUrl = {
    "api_permissionQuery": "/permission/queryByUserCode", // 获取用户数据权限列表
    "api_permissionUpdate": "/permission/addOrUpdate", // 添加或更新
}

// initial state
const state = {
    permissionList: [],
}

// getters
const getters = {
    getPermissionList: state => {
        return state.permissionList
    },


}

// actions
const actions = {
    getPermissionList: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_permissionQuery,
            method: "GET",
            params,
        };
        return request(option).then(res => res.data)
        // .then(res => {
        //     if (res.code == 200) {
        //         commit('PERMISSION_QUERY', res.data && res.data.permissionData || []);
        //     } else {
        //         commit('PERMISSION_QUERY', []);
        //     }
        // }).catch(err => {
        //     commit('PERMISSION_QUERY', []);
        // })
    },
    updatePermissionList: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_permissionUpdate,
            method: "POST",
            data: params,
        };
        return request(option).then(res => res.data)
    },
}


// mutations
const mutations = {
    PERMISSION_QUERY: (state, pageData) => {
        state.permissionList = pageData;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js